$bog_fragile_demo_rename_heir1 $bog_fragile_demo_rename_base1
	heading \Наследник
